export default "__VITE_ASSET__UsF98eU6__"